import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { signOut } from '../auth';
import { IconMenu, IconClose } from './Icons';

const navClass = ({ isActive }) =>
  isActive ? 'site-nav__link is-active' : 'site-nav__link';

export default function Header({ token, setToken }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Collapse the mobile menu whenever the route changes, otherwise it
  // stays open over the page the visitor just navigated to.
  useEffect(() => setOpen(false), [location.pathname]);

  const handleLogout = () => {
    signOut();
    setToken(null);
  };

  return (
    <header className="site-header" role="banner">
      <div className="site-header__inner">
        <Link to="/" className="brand" aria-label="Usman's Garden, home">
          <img src="/logo.png" alt="" className="brand__mark" />
          <span>
            <span className="brand__name">Usman&rsquo;s Garden</span>
            <span className="brand__tag">Plant records &amp; growing notes</span>
          </span>
        </Link>

        <button
          type="button"
          className="nav-toggle"
          aria-label="Menu"
          aria-expanded={open}
          aria-controls="site-nav"
          onClick={() => setOpen(v => !v)}
        >
          {open ? <IconClose /> : <IconMenu />}
          <span className="nav-toggle__label">Menu</span>
        </button>

        <nav id="site-nav" className={open ? 'site-nav is-open' : 'site-nav'} aria-label="Main">
          <NavLink to="/" className={navClass} end>Plants</NavLink>
          <NavLink to="/guides" className={navClass}>Guides</NavLink>
          <NavLink to="/about" className={navClass}>About</NavLink>

          {token ? (
            <>
              <span className="site-nav__divider" aria-hidden="true" />
              <span className="site-nav__admin">
                <NavLink to="/admin" className={navClass} end>Dashboard</NavLink>
                <NavLink to="/admin/plant/new" className={navClass}>Add plant</NavLink>
                <NavLink to="/admin/gallery" className={navClass}>Upload</NavLink>
                <button type="button" className="btn btn-secondary btn-sm" onClick={handleLogout}>
                  Sign out
                </button>
              </span>
            </>
          ) : (
            <>
              <span className="site-nav__divider" aria-hidden="true" />
              <Link to="/login" className="btn btn-secondary btn-sm">Admin</Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
